// Pure helpers for the Analytics page: counters with their change, a gap-free daily chart, and bar colours.
import { change } from './executiveLogic';

export const PERIODS = [7, 30, 90];

const rate = (v) => (v == null ? '-' : `${v}%`);
const mins = (v) => (v == null ? '-' : v < 1 ? '<1 min' : `${v} min`);
const days = (v) => (v == null ? '-' : `${v} d`);

// Six counters, each with the value for this period, a note, and how it moved against the period before.
export function kpis(data) {
  const c = data.current;
  const p = data.previous;
  return [
    { label: 'Scans run', value: c.scans, note: `${p.scans} before`, delta: change(p.scans, c.scans, { lowerIsBetter: false }) },
    { label: 'Scans that finished', value: rate(c.success_rate), note: `${c.failed} failed`, delta: change(p.success_rate, c.success_rate, { lowerIsBetter: false, unit: ' pts' }) },
    { label: 'Average scan time', value: mins(c.avg_scan_minutes), note: p.avg_scan_minutes == null ? 'no earlier figure' : `${mins(p.avg_scan_minutes)} before`, delta: change(p.avg_scan_minutes, c.avg_scan_minutes, { unit: ' min' }) },
    { label: 'New findings', value: c.new_findings, note: `${p.new_findings} before`, delta: change(p.new_findings, c.new_findings) },
    { label: 'Cases opened', value: c.cases_opened, note: `${c.cases_closed} closed`, delta: change(p.cases_opened, c.cases_opened) },
    { label: 'Average time to fix', value: days(c.avg_days_to_fix), note: p.avg_days_to_fix == null ? 'no earlier figure' : `${days(p.avg_days_to_fix)} before`, delta: change(p.avg_days_to_fix, c.avg_days_to_fix, { unit: ' d' }) }
  ];
}

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// One entry per day for the period (empty days are zeros) so the chart has no gaps; long periods are grouped by week.
export function chartDays(daily, periodDays, today = new Date()) {
  const byDate = Object.fromEntries(daily.map((d) => [d.date, d]));
  const out = [];
  for (let i = periodDays - 1; i >= 0; i -= 1) {
    const d = new Date(today.getFullYear(), today.getMonth(), today.getDate() - i);
    const row = byDate[ymd(d)] || {};
    out.push({ date: ymd(d), scans: row.scans || 0, findings: row.findings || 0, cases: row.cases || 0 });
  }
  if (periodDays <= 120) return out;
  const weeks = [];
  for (let i = 0; i < out.length; i += 7) {
    const chunk = out.slice(i, i + 7);
    weeks.push({ date: chunk[0].date, scans: chunk.reduce((n, r) => n + r.scans, 0), findings: chunk.reduce((n, r) => n + r.findings, 0), cases: chunk.reduce((n, r) => n + r.cases, 0) });
  }
  return weeks;
}

export const chartMax = (rows) => Math.max(1, ...rows.flatMap((r) => [r.scans, r.findings, r.cases]));

// Share of scans that finished: green when healthy, amber when shaky, red when poor.
export const rateColor = (v) => (v == null ? '#64748b' : v >= 90 ? '#22c55e' : v >= 75 ? '#f59e0b' : '#ef4444');
